import React, { useEffect, useState } from 'react';
import { callAPI } from '../../../utils';

const generateYears = ({ start = 1900 } = {}) => {
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= start; i--) {
    years.push({ value: i, label: i.toString() });
  }
  return years;
};

const filterFeedbackTags = (tags, attribute) => {
  return tags ? tags.filter(tag => tag.data.attribute === attribute) : [];
};




export const getConfigTutorData = async () => {
    let staticTables = {};
    let users = [];

    try {
        const staticResponse = await callAPI({
            request: "database/getStaticTables",
            method: "post",
            params: { tables: [
                'gender', 'hdyhau', 'tutorlevels', 'capacitytags', 'caracessability', 'licencetimeline', 'websiteprofile', 'feedbacktags', 'striketypes',
                'subjects', 'experiences/atributes', 'learningdifficulty', 'otherroletags', 'englishnovels', 'curriculums', 'highschools', 'universities', 'statuses', 'program', 'travelwillingness', 'methodofdelivery'
                ]},
        });
        staticTables = staticResponse.data;

        const usersResponse = await callAPI({
            request: "getUsers",
            method: "get",
        });
        users = [{ label: "None", value: null }, ...usersResponse.data.map(entry => ({ label: entry.name, value: entry.userId }))];
    } catch (error) {
        console.error("Failed to fetch data:", error.message);
    }

    const tutorFieldsConfig = {
        type: "tutor",
        sections: [
            {
                section: "Personal Information",
                fields: [
                { label: "Name", id: "personalInfo.name", type: "text", required: true },
                { label: "Gender", id: "personalInfo.genderId", type: "select", required: true, options: staticTables?.gender || [] },
                { label: "Email", id: "personalInfo.email", type: "email", required: true },
                { label: "Phone Number", id: "personalInfo.phoneNumber", type: "tel", required: true },
                { label: "Address", id: "personalInfo.address", type: "text", required: true },
                { label: "How Did You Hear About Us", id: "tutors.HDYHAU", type: "select", options: staticTables?.howdidyouhearaboutus || [] },
                ]
            },
            {
                section: "Admin Information",
                fields: [
                { label: "Level", id: "adminInfo.level", type: "select", required: true, options: staticTables?.level || [], default: 1 },
                { label: "Capacity", id: "adminInfo.capacity", type: "select", options: staticTables?.capacity || [], required: true },
                { label: "Program", id: "adminInfo.program", type: "select", options: staticTables?.program || [], required: true, default: 1 },
                { label: "Website Profile", id: "adminInfo.websiteProfile", type: "select", options: staticTables?.websiteprofile || [] },
                ]
            },
            {
                section: "Tutoring Information",
                fields: [
                { label: "Subjects", id: "junctionData.subjects", type: "multi-select", options: staticTables?.subjects || [], required: true },
                { label: "Curriculums", id: "junctionData.curriculums", type: "multi-select", options: staticTables?.curriculums || [] },
                { label: "Method of Delivery", id: "tutors.methodOfDelivery", type: "select", options: staticTables?.methodofdelivery || []},
                { label: "English Novels", id: "junctionData.englishNovels", type: "multi-select", options: staticTables?.englishnovels || [] },
                { label: "History Revolutions", id: "tutors.historyRevolutions", type: "textarea" },
                { label: "Parent Feedback", id: "tutors.parentFeedback", type: "textarea" },
                { label: "Travel Willingness", id: "tutors.travelWillingness", type: "select", options: staticTables?.travelwillingness || [] },
                ]
            },
            {
                section: "Educational Background",
                fields: [
                { label: "Highschool", id: "schooling.highschool", type: "select", options: staticTables?.highschool || [] },
                { label: "Graduation Year", id: "schooling.graduationYear", type: "select", options: generateYears() },
                { label: "Highschool Subjects", id: "schooling.highschoolSubjects", type: "textarea" },
                { label: "University", id: "schooling.university", type: "select", options: staticTables?.university || [] },
                { label: "Degree Name", id: "schooling.degreeName", type: "text" },
                { label: "Degree Commencement", id: "schooling.degreeCommencement", type: "select", options: generateYears() },
                { label: "Degree Conclusion", id: "schooling.degreeConclusion", type: "select", options: generateYears() },
                ]
            },
            {
                section: "Business Information",
                fields: [
                { label: "ABN (11 Digit)", id: "business.ABN", type: "text", required: true },
                { label: "WWCC", id: "business.WWCC", type: "text", required: true },
                { label: "Bank Name", id: "business.bankName", type: "text", required: true },
                { label: "Account Name", id: "business.accountName", type: "text", required: true },
                { label: "BSB (6 Digit)", id: "business.BSB", type: "text", required: true },
                { label: "Account Number (6-10 Digit)", id: "business.accountNumber", type: "text", required: true },
                ]
            },
            {
                section: "Status Information",
                fields: [
                { label: "Status", id: "status.status", type: "select", options: staticTables?.status || [], required: true },
                { label: "Status Information", id: "status.statusInfo", type: "textarea" },
                { label: "Status Check-in Date", id: "status.statusCheckin", type: "date" },
                ]
            },
            {
                section: "Additional Information",
                fields: [
                { label: "Experiences", id: "junctionData.experiences", type: "multi-select", options: staticTables?.experience || [] },
                { label: "Other Roles", id: "junctionData.otherRoles", type: "multi-select", options: staticTables?.otherroles || [] },
                { label: "Learning Difficulties", id: "junctionData.learningDifficulties", type: "multi-select", options: staticTables?.learningdifficulty || [] },
                { label: "Learning Difficulties Paragraph", id: "tutors.learningDifficultiesParagraph", type: "textarea" },
                ]
            },
            {
                section: "Location Information",
                fields: [
                { label: "Primary Tutoring Address", id: "location.primaryAddress", type: "text"},
                { label: "Secondary Tutoring Address", id: "location.secondaryAddress", type: "text" },
                ]
            },
            {
                section: "Uneditable Information",
                fields: [
                    { label: "XP", id: "tutors.xp", type: "number", disabled: true, value: {value: 0} },
                    { label: "Strike", id: "disciplineData.strikeTypeId", type: "select", disabled: true, options: staticTables?.striketypes || []  },
                    { label: "Strike description", id: "disciplineData.strikeDescription", disabled: true, type: "textarea" },
                    { label: "Created time", id: "usercreationtimestamps.createdDate", disabled: true, type: "text" },
                    { label: "Created by", id: "usercreationtimestamps.createdBy", disabled: true, type: "select", options: users },
                ]
            }
        ],
    }

    return tutorFieldsConfig;
}

export const getConfigStudentData = async () => {
    let staticTables = {};
    let users = [];

    try{
        const staticResponse = await callAPI({
            request: "database/getStaticTables",
            method: "post",
            params: { tables: [
                "gender", "methodofdelivery", "frequency", "schools", "yearlevel", "cancellations", "statuses",
                "tutorrequirementstags", "learningdifficulty", "subjects"
               ]},
        });
        staticTables = staticResponse.data;

        const usersResponse = await callAPI({
            request: "getUsers",
            method: "get",
        });
        users = [{ label: "None", value: null }, ...usersResponse.data.map(entry => ({ label: entry.name, value: entry.userId }))];
    } catch (error) {
        console.error("Failed to fetch data:", error.message);
    }

    const studentFieldsConfig = {
        sections: [
          {
            section: "Personal Information",
            fields: [
              { label: "Name", id: "personalInfo.name", type: "text", required: true },
              { label: "Parents Name", id: "students.parentName", type: "text", required: true },
    
              { label: "Gender", id: "personalInfo.gender", type: "select", options: staticTables?.gender || [] },
              { label: "Email", id: "personalInfo.email", type: "email", required: true },
              { label: "Phone Number", id: "personalInfo.phoneNumber", type: "tel", required: true },
              { label: "Address", id: "personalInfo.address", type: "text", required: true  },
    
            ]
          },
          { section: "Tutoring Information",
            fields: [
              { label: "Method of Delivery", id: "students.methodOfDelivery", type: "select", options: staticTables?.methodofdelivery || []},
    
              { label: "School", id: "students.school", type: "select", options: staticTables?.school || [] },
              { label: "Year Level", id: "students.yearLevel", type: "select", options: staticTables?.yearlevel || [] },
    
              { label: "Subjects", id: "junctions.subjects", type: "multi-select", options: staticTables?.subjects || [], required: true },
              {type:"break"},
    
    
              { label: "Frequency", id: "students.frequency", type: "select", options: staticTables?.frequency || []},
              { label: "Frequency Notes", id: "students.frequencyNotes", type: "textarea"},
              { label: "Availability", id: "students.availability", type: "textarea"},
              {type:"break"},
    
              { label: "Tutor Requirements", id: "junctions.tutorRequirements", type: "multi-select", options: staticTables?.tutorrequirements || [] },
              { label: "Learning Difficulties", id: "junctions.learningDifficulty", type: "multi-select", options: staticTables?.learningdifficulty || []},
              {type:"break"},
    
              { label: "Cancellations", id: "students.cancellations", type: "select", options: staticTables?.cancellations || [], disabled: true },
    
              { label: "Finance Notes", id: "students.financeNotes", type: "textarea" },
              { label: "Call Notes", id: "students.callNotes", type: "textarea"},
            ]
          },
          {
            section: "Status Information",
            fields: [
              { label: "Status", id: "statussystem.status", type: "select", options: staticTables?.status || [], required: true },
              { label: "Status Information", id: "statussystem.statusInfo", type: "textarea" },
              { label: "Status Check-in Date", id: "statussystem.statusCheckin", type: "date" },
            ]
          },

          {
            section: "Uneditable Information",
            fields: [
                { label: "Notes", id: "students.notes", type: "textarea", disabled: true},
                { label: "Associated Tutor/s", id: "junctions.associatedTutors", type: "textarea", disabled: true},
                { label: "Created time", id: "usercreationtimestamps.createdDate", disabled: true, type: "text" },
                { label: "Created by", id: "usercreationtimestamps.createdBy", disabled: true, type: "select", options: users},
            ]
        }
        ],
        requiredFields: [],
    };

    return studentFieldsConfig
}

